 import styled from 'styled-components';

 export const CountryPickerSection=styled.section`
      padding:2rem 0rem;
 `;

 export const CpContainer = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
 `;


 export const CpFormControl = styled.div`
    width:70vw;
 `;
 
 export const CpSelect = styled.select`
    width:100%;
    height:2.5rem;
    border:none;
    background-color:#0f1340;
    color:#f1f1f1;
    padding:0.5rem;
    font-size:18px;
    outline:none;
 `;
 
 export const CpOption= styled.option`
 
 `;
 